import { Dialog, Icon, Link, useDialogState } from "@resource/atlas";
import Loom from "components/Loom/Loom";
import { ReactElement } from "react";
import useIntercom from "utils/useIntercom";

import { LinkItem } from "./SurveyHelpfulLinks";

type Props = {
  links: LinkItem[];
};

function RenderLink(item: LinkItem): ReactElement {
  const dialog = useDialogState();
  const { callIntercom } = useIntercom();
  const { href, icon, label } = item;
  const isLoom = href.includes("loom.com");
  const isIntercomTour = href.includes("product_tour_id=");
  return (
    <span key={href}>
      <Link
        href={href}
        key={href}
        onClick={(e: React.MouseEvent) => {
          if (isLoom) {
            e.preventDefault();
            dialog.show();
          } else if (isIntercomTour) {
            e.preventDefault();
            const productTourId = new URL(href).searchParams.get(
              "product_tour_id"
            );
            if (productTourId) {
              callIntercom("startTour", productTourId);
            }
          }
        }}
        target="_blank"
      >
        <>
          <Icon className="inline-block mr-1" content={icon} />
          {label}
        </>
      </Link>
      <Dialog.Root state={dialog}>
        <Dialog.Content size="medium">
          {isLoom && <Loom videoUrl={href} autoplay />}
        </Dialog.Content>
      </Dialog.Root>
    </span>
  );
}

function LinkList({ links }: Props): ReactElement {
  return (
    <div className="flex gap-8 text-body-md">
      {links.map((link) => RenderLink(link))}
    </div>
  );
}

export default LinkList;
